import {
  ArrowLeftIcon,
  EllipsisVerticalIcon,
} from "@heroicons/react/24/outline";
import React, { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
interface Props {
  title?: string;
  iconRight?: ReactNode;
  iconLeft?: ReactNode;
  className?: string;
  customTitle?: ReactNode;
}
export const Breadcum = ({
  title,
  iconRight,
  iconLeft,
  className,
  customTitle,
}: Props) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-wrap justify-between items-center h-12 fixed top-0 left-0 right-0 w-full bg-base-300 py-2 px-3 z-10">
      <div className="flex-none">
        {iconLeft || (
          <ArrowLeftIcon className="w-8 h-8 p-1" onClick={() => navigate(-1)} />
        )}
      </div>
      {customTitle ? (
        <div className="grow text-left text-xl">{customTitle}</div>
      ) : (
        <div className="grow text-center text-xl">{title}</div>
      )}
      <div className="flex-none">
        {iconRight || <div className="w-8 h-8 p-1"></div>}
      </div>
    </div>
  );
};
